
export default {
  name: 'PrivacyPolicy',
}
